import Vue from 'vue'
import Router from 'vue-router'
import { store } from './store'

const routerOptions = [
  { name: 'frontpage', path: '/', component: 'Frontpage' },
  { name: 'trailer', path: '/trailers/:id', component: 'trailers/Trailer' },
  { name: 'tire-change', path: '/trailers/:id/change', component: 'trailers/TireChange', props: true },
  { name: 'tire-remarks', path: '/trailers/:id/remarks', component: 'trailers/TireRemarks' },
  { name: 'tire-workshop', path: '/trailers/:id/workshop', component: 'trailers/TireWorkshop' },
  { name: 'completed', path: '/completed/:id', component: 'Completed' },
  { name: 'notfound', path: '*', component: 'pages/NotFound' },
]

// Map and import components.
const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/views/${route.component}.vue`),
  }
})

Vue.use(Router)

// Logout uses a before handler to redirect and has no component.
routes.push({
  path: '/logout',
  beforeEnter: async function (to, from, next) {
    await store.dispatch('app/logout')
  }
})

const router = new Router({
  mode: 'history',
  routes
})

// Make sure navbar collapses when changing route.
router.beforeEach((to, from, next) => {
  $('#navbarNav').collapse('hide')

  if (store.state.user.isLoggedIn) {
    next()
    return
  }

  store.dispatch('app/login')
})

router.afterEach((to, from) => {
  window.scrollTo({ top: 0 })
})

export default router
